import { Person } from "models/person";

export function getStatusText(person: Person) {
    if (person.isModerator())
        return labels.Moderator.toUpperCase();
    else if (person.isObserver())
        return labels.Observer.toUpperCase();

    return undefined;
}